import Api from '../api'
import Apollo from '@didi/apollo-sdk-javascript'
import { requestDataHelper, requestDataLoadingHelper } from '@/utils/request/helper'
// import allSettled from '@ungap/promise-all-settled'
import { adjustItemStatus } from '../data'
import { RELATION_TYPE } from '../consts/dishes'
import { isFromBDAPP } from '@/utils/bridge/fromBDAPP'

// const $settled = allSettled.bind(Promise)
const removeEmptyChildren = options => {
  return options.map(option => {
    if (option.subCateList && option.subCateList.length === 0) {
      // 如果子节点是空数组，则不设置子节点
      return { ...option, subCateList: undefined }
    } else if (option.subCateList) {
      // 递归处理子节点
      return { ...option, subCateList: removeEmptyChildren(option.subCateList) }
    }
    // 如果没有子节点或子节点不是数组，则原样返回
    return option
  })
}

const getItemPermissionConfig = async () => {
  return new Promise((resolve, reject) => {
    try {
      Apollo.getToggle(
        {
          name: 'b_merchant_dish_permissions_br',
          global: true,
          key: Math.random(),
        },
        result => {
          const { code, data = {} } = result
          const { params = {} } = data.b_merchant_dish_permissions_br || {}
          const { contractorId = '' } = params
          if (code === 0) {
            resolve(contractorId)
          } else {
            resolve('')
          }
        },
      )
    } catch (err) {
      console.log(err)
      reject(err)
    }
  })
}
const state = {
  isOpenapiShop: false,
  itemInfo: {},
  modifierGroupInfo: {},
  menuList: [],
  settingInfo: {
    shopInfo: {
      shopId: '',
      shopBrandContractorRelation: RELATION_TYPE.OWNER, // 1: 自营 2: 加盟
    },
  },
  // 加盟门店菜品权限
  itemAuth: {
    storeShowMenuInfo: 1, // 门店菜单查看权限
    storeUpdateItemStatus: 1, // 菜品上下架
  },
  // 渠道列表
  businessChannelList: [1],

  itemGrayscale: {
    // 菜品功能灰度控制，以后所有菜品灰度，统一用此字段
    isItemAutoOnline: false, // 菜品自动上架灰度
    itemDiagnosis: false, // 菜品诊断灰度
    combo: false, // 套餐
    comboCateBlacklist: true, // 套餐分类黑名单
    comboPrice: false, // 套餐价格校验灰度
    backendCateTreeList: false, // 后台分类树列表
    createItemDiagnosis: false, // 创建菜品实时诊断
    offlineMenu: false, // 堂食菜单
    multiChannelSwitch: false, // 多业务渠道
    priceNotControlGray: false, // 价格管控黑名单
  },

  /**
   * @name 诊断菜品数量，为了区分入口，从storage初始化
   * shopId 当前缓存的门店 用于对比门店是否同一个，主要是 加特兰 和 PAD 进来，门店不唯一
   * problemItemCount 问题菜品数
   * optimizeableItemCount 可优化菜品数
   * recommendComboCount 推荐套餐数
   */

  // 问题菜品id映射表
  problemItemIdMap: {},

  highPriceItemIds: [], // 高价菜品id
  highPriceVersionNum: '0', // 高价菜品版本号
  showHighPriceItemAlert: false, // 是否显示高价菜品弹窗
  showUpdatePriceTip: false, // 是否显示改价失败菜品弹窗
  itemPermissionWhiteList: [], // 菜品权限主体白名单
  offlineMenuInfo: {
    auditStatus: -1,
    offlineMenuAuditComment: {
      reason: [],
      remark: '',
    },
    menuUrls: {
      imgUrls: [],
      pdfUrls: [],
    },
    extraInfo: '',
    menuSource: 0,
  },
  baselineMenuTypeAndPDR: {},
}

const getters = {
  isGroceryShop(state, getters, rootState) {
    return +rootState.currentShop.businessType === 3
  },
  isSupportMultiChannelPrice(state, getters, rootState, rootGetters) {
    const channelList = rootState.businessChannelList || [1]
    const _deliveryPrice = channelList.includes(1)
    const _tnPrice = channelList.includes(2)
    const settingInfo = rootState.settingInfo || {}
    const pickupInfo = settingInfo.pickup || {}
    const _pickupPrice = Boolean(
      pickupInfo && pickupInfo.contractorIsPickup && pickupInfo.shopIsPickup,
    )
    const isOpenapiShop = state.isOpenapiShop || false
    const isGrey = state.itemGrayscale.multiChannelSwitch || false

    return {
      // 非openapi门店 && 有多服务 && 命中灰度 && 非Grocery门店
      isOpen: !isOpenapiShop && isGrey,
      _deliveryPrice,
      _pickupPrice,
      _tnPrice,
    }
  },
  currentMenu(state) {
    return state.menuList[0]
  },
  isNewHighPriceVersion(state) {
    return +state.highPriceVersionNum === 1
  },
  isFranchisee: state =>
    +state.settingInfo?.shopInfo?.shopBrandContractorRelation === RELATION_TYPE.FRANCHISEE,
}

const mutations = {
  SET_ITEM_AUTH(state, payload) {
    state.itemAuth = {
      ...state.itemAuth,
      ...payload,
    }
  },
  RESET_ITEM_AUTH(state) {
    state.itemAuth = {
      storeUpdateItemStatus: 1,
      storeShowMenuInfo: 1,
    }
  },

  UPDATE_SETTING_INFO(state, payload) {
    state.settingInfo = payload
  },
  SET_BASELINE_MENU_TYPE_AND_PDR(state, payload) {
    state.baselineMenuTypeAndPDR = payload || {}
  },
  SET_ITEM_PERMISSION_WHITE_LIST(state, payload) {
    state.itemPermissionWhiteList = payload
  },

  SET_PROBLEM_ITEM_ID_MAP(state, value = {}) {
    state.problemItemIdMap = value
  },

  UPDATE_ITEM_INFO(state, itemMap) {
    const idList = Object.keys(itemMap)
    const itemInfo = {}
    idList.forEach(id => {
      const item = state.itemInfo[id]
      itemInfo[id] = {
        ...item,
        ...itemMap[id],
      }
    })
    state.itemInfo = Object.assign({}, state.itemInfo, itemInfo)
  },
  DELETE_ITEM_INFO(state, idList) {
    idList.forEach(id => {
      delete state.itemInfo[id]
    })
  },
  CLEAR_ITEM_INFO(state) {
    state.itemInfo = {}
  },
  UPDATE_MODIFIER_GROUP_INFO(state, modifierGroupMap) {
    const idList = Object.keys(modifierGroupMap)
    const modifierGroupInfo = {}
    idList.forEach(id => {
      const existedModifierGroup = state.modifierGroupInfo[id]
      const newModifierGroup = modifierGroupMap[id]
      // 接口/item/itemv4/listbyids没有返回字段price,priceSplit
      if (existedModifierGroup && existedModifierGroup.itemInfoList) {
        const itemIdMap = {}
        existedModifierGroup.itemInfoList.forEach(item => {
          itemIdMap[item.itemId] = item
        })
        if (newModifierGroup && newModifierGroup.itemInfoList) {
          newModifierGroup.itemInfoList = newModifierGroup.itemInfoList.map(item => {
            return {
              ...itemIdMap[item.itemId],
              ...item,
            }
          })
        }
      }

      modifierGroupInfo[id] = {
        ...existedModifierGroup,
        ...modifierGroupMap[id],
      }
    })
    state.modifierGroupInfo = Object.assign({}, state.modifierGroupInfo, modifierGroupInfo)
  },
  DELETE_MODIFIER_GROUP_INFO(state, idList) {
    idList.forEach(id => {
      delete state.modifierGroupInfo[id]
    })
  },
  CLEAR_MODIFIER_GROUP_INFO(state) {
    state.modifierGroupInfo = {}
  },
  SET_MENU_LIST(state, payload) {
    state.menuList = payload
  },

  SET_ITEM_GRAYSCALE(state, payload) {
    state.itemGrayscale = Object.assign({}, state.itemGrayscale, payload)
  },

  UPDATE_HIGH_PRICE_ITEM_IDS(state, payload) {
    const { highPriceItemIds = [], showAlert = false, versionNum = '0' } = payload
    state.highPriceItemIds = highPriceItemIds
    state.showHighPriceItemAlert = showAlert
    state.highPriceVersionNum = versionNum
  },
  UPDATE_UPDATE_PRICE_TIP(state, payload) {
    const { result = false } = payload
    state.showUpdatePriceTip = result
  },
  UPDATE_OFFLINE_MENU_INFO(state, payload) {
    state.offlineMenuInfo = Object.assign({}, state.offlineMenuInfo, payload)
  },
  /**
   * 更新是否为openapi门店
   */
  UPDATE_IS_OPENAPI_SHOP(state, isOpenapiShop) {
    state.isOpenapiShop = isOpenapiShop
  },
}
const actions = {
  async GET_ITEM_AUTH_MAP({ commit, rootState }) {
    console.log('rootState', rootState)
    try {
      const res = await requestDataLoadingHelper(Api.getItemAuthMap, {
        country: 'BR',
        relationType: 2,
      })
      const { authFuncMap = {} } = res || {}
      console.log('authFuncMap', authFuncMap)
      if (authFuncMap) {
        commit('SET_ITEM_AUTH', authFuncMap)
      } else {
        commit('RESET_ITEM_AUTH')
      }
      return res
    } catch (e) {
      commit('RESET_ITEM_AUTH')
      console.log(e)
    }
  },

  async GET_SHOP_SETTING_INFO({ commit }) {
    const res = await requestDataLoadingHelper(Api.getShopSettingInfo)
    commit('UPDATE_SETTING_INFO', res)
  },

  async GET_BASELINE_MENU_TYPE_AND_PDR({ commit, rootState }) {
    const res = await requestDataHelper(Api.getBaselineMenuTypeAndPDR)
    commit('SET_BASELINE_MENU_TYPE_AND_PDR', res.spreadRatioMap)
  },
  async GET_ITEM_PERMISSION_WHITE_LIST({ commit, rootState }) {
    let res = await getItemPermissionConfig()
    if (!res) {
      commit('SET_ITEM_PERMISSION_WHITE_LIST', [])
      return
    }
    // 中文符号逗号替换成英文逗号
    res = res.replace(/，/g, ',')
    // 去除前后多余的空格
    const whiteList = (res.split(',') || []).map(item => item.trim())
    commit('SET_ITEM_PERMISSION_WHITE_LIST', whiteList)
  },
  async GET_UPDATE_PRICE_TIP({ commit, rootState }) {
    const res = await requestDataHelper(Api.getUpdatePriceTip)
    commit('UPDATE_UPDATE_PRICE_TIP', res)
  },

  async GET_PROBLEM_ITEM_ID_MAP({ commit }, payload) {
    const res = await requestDataHelper(Api.getProblemItemIds, payload)
    const { diagnosisItems = {} } = res
    const resObj = {}
    for (const key in diagnosisItems) {
      diagnosisItems[key].forEach(e => {
        resObj[e] = key
      })
    }
    commit('SET_PROBLEM_ITEM_ID_MAP', resObj)
  },

  CLEAR_ITEM_INFO_AND_MODIFIER_GROUP_INFO({ commit }) {
    commit('CLEAR_ITEM_INFO')
    commit('CLEAR_MODIFIER_GROUP_INFO')
  },
  UPDATE_ITEM_INFO_AND_MODIFIER_GROUP_INFO({ commit }, payload) {
    const { itemInfo = {}, modifierGroupInfo = {} } = payload
    Object.keys(itemInfo).forEach(itemId => {
      const item = itemInfo[itemId]
      itemInfo[itemId] = adjustItemStatus(item)
    })

    commit('UPDATE_ITEM_INFO', itemInfo)
    commit('UPDATE_MODIFIER_GROUP_INFO', modifierGroupInfo)
  },

  /**
   * 接口返回的菜品和选项组 存到map里
   * 接口：/item/itemv4/list
   * 接口：/item/itemv4/detail
   */
  UPDATE_ITEM_INFO_TO_MAP({ dispatch }, payload) {
    const { itemInfo = {}, modifierGroupInfo = {}, onlyFirstLevel = false } = payload
    // 调整选项组数据
    // 接口返回的 includedByItemList 和 不可用 删掉 避免覆盖已有字段
    Object.keys(modifierGroupInfo).forEach(modifierGroupId => {
      const mg = modifierGroupInfo[modifierGroupId]
      if (mg) {
        delete mg.includedByItemList
      }
    })

    Object.keys(itemInfo).forEach(itemId => {
      const itemDetail = itemInfo[itemId]
      // 后面需要后端对接口返回做适当的调整 本来二期时候我就要求做，但后端没来得及做
      if (!onlyFirstLevel && itemDetail.modifierGroups && itemDetail.modifierGroups.length) {
        itemDetail.modifierGroups.forEach(({ modifierGroupId, items = [] }) => {
          const itemInfoList = items.map(item => {
            // 只要这三个字段
            const newItem = {
              itemId: item.itemId, // 关联item的itemId
            }
            // 如果有价格就覆盖掉 item/itemv4/listbyids接口没有返回的price和priceSplit有异常 需要后端改正
            if (item.price !== null && item.price !== undefined) {
              newItem.price = item.price // 选项组对菜品修改后的价格
            }
            if (item.priceSplit) {
              newItem.priceSplit = {
                ...item.priceSplit,
              } // 同 price
            }
            return newItem
          })
          const modifierGroup = modifierGroupInfo[modifierGroupId]
          modifierGroupInfo[modifierGroupId] = {
            ...modifierGroup,
            itemInfoList,
          }
        })
      }
    })
    return dispatch('UPDATE_ITEM_INFO_AND_MODIFIER_GROUP_INFO', {
      modifierGroupInfo,
      itemInfo,
    })
  },

  // 获取所有 菜单&分类&菜品
  async GET_ALL_MENU_CATE_ITEM({ commit }) {
    const result = await requestDataLoadingHelper(Api.getListIdsWithMenuAndCate)
    if (!result) {
      return
    }
    const menuList = result.menuList || []
    let firstComboCateId = null
    if (menuList[0] && menuList[0].cateList) {
      menuList[0].cateList.some((e, index) => {
        if (e.cateTags && e.cateTags.indexOf(1) !== -1) {
          firstComboCateId = e.cateId
          menuList[0].cateList[index].isComboCateFlag = true
          return true
        }
        return false
      })
      menuList[0].hasComboCate = !!firstComboCateId
      menuList[0].firstComboCateId = firstComboCateId
    }
    commit('SET_MENU_LIST', menuList)
  },

  // request 菜品详情
  async GET_ITEM_DETAIL({ dispatch, state }, payload) {
    const { itemId, loading = true } = payload
    const requestHelper = loading ? requestDataLoadingHelper : requestDataHelper
    const res = await requestHelper(Api.getItemDetailV4, {
      itemId,
      includedByModifierGroup: 1, // 是否需要查该菜品被选项组包含过
    })
    if (!res) {
      return
    }
    const { showIds } = res
    if (itemId !== showIds[0]) {
      return
    }
    const { itemInfo = {}, modifierGroupInfo = {} } = res

    const payloadItemInfo = state.itemInfo[itemId]

    // 新版套餐没法返回子菜的选项组, 如果请求的是套餐的detail, 做特殊处理
    if (
      payloadItemInfo &&
      payloadItemInfo.additionalType === 1 &&
      payloadItemInfo.comboVersion === 2
    ) {
      Object.keys(itemInfo).forEach(resItemId => {
        // 如果是主菜, 不做处理
        if (resItemId === itemId) return

        // 如果是子菜, 不用detail里面的选项组做更新
        delete itemInfo[resItemId].modifierGroups
      })
    }

    dispatch('UPDATE_ITEM_INFO_TO_MAP', {
      itemInfo,
      modifierGroupInfo,
    })
    return res
  },

  async GET_ITEM_DETAIL_BY_IDS({ dispatch }, payload) {
    const { itemIdList = [], loading = true } = payload
    if (!itemIdList.length) {
      return
    }
    const requestHelper = loading ? requestDataLoadingHelper : requestDataHelper
    const res = await requestHelper(Api.getItemDetailByIds, {
      itemIdList,
    })
    if (!res) {
      return
    }
    const { itemInfo = {}, modifierGroupInfo = {} } = res
    return dispatch('UPDATE_ITEM_INFO_TO_MAP', {
      itemInfo,
      modifierGroupInfo,
    })
  },
  async CONCURRENCE_GET_ITEM_DETAIL_BY_IDS({ state, dispatch }, array) {
    const count = 40
    const quotient = parseInt(array.length / count)
    for (let index = 0; index <= quotient; index++) {
      const startIndex = count * index
      const endIndex = startIndex + count
      const itemIdList = array.slice(startIndex, endIndex)
      if (!itemIdList.length) {
        return
      }
      Api.getItemDetailByIds({
        itemIdList,
      })
        .then(res => {
          if (!res || !res.data) {
            return
          }
          const { itemInfo = {}, modifierGroupInfo = {} } = res.data
          dispatch('UPDATE_ITEM_INFO_AND_MODIFIER_GROUP_INFO', {
            itemInfo,
            modifierGroupInfo,
          })
        })
        .catch(() => {})
    }
  },

  // 获取菜品功能灰度
  async GET_ITEM_GRAYSCALE_SETTINGS({ commit, state }) {
    const result = await Api.getItemGrayscale({
      showMap: Object.keys(state.itemGrayscale),
    })
    if (result) {
      const { data = {} } = result
      commit('SET_ITEM_GRAYSCALE', data)
    }
  },

  async GET_HIGH_PRICE_ITEM_IDS({ commit, rootState }) {
    let result = []
    try {
      result = await requestDataHelper(Api.getHighPriceItemIds)
    } catch (e) {
      console.log('获取高价菜品id失败', e)
    }
    const { highPriceItemIDs = [], showAlert = false, versionNum } = result
    commit('UPDATE_HIGH_PRICE_ITEM_IDS', {
      highPriceItemIds: highPriceItemIDs || [],
      showAlert: showAlert || false,
      versionNum: versionNum || '0',
    })
  },
  async GET_SHOP_OFFLINE_MENU_INFO({ commit }) {
    try {
      const result = await requestDataHelper(Api.getShopOfflineMenuInfo)
      commit('UPDATE_OFFLINE_MENU_INFO', result)
    } catch (e) {
      commit('UPDATE_OFFLINE_MENU_INFO', {})
      console.log('获取堂食菜单信息失败', e)
    }
  },
  /**
   * 校验是否为openapi门店
   */
  async CHECK_IS_OPENAPI_SHOP({ commit, state }) {
    const result = await requestDataHelper(Api.checkIsOpenapiShop)
    commit('UPDATE_IS_OPENAPI_SHOP', result && result.isOpenApi)
  },

  async GET_SHOP_INFO({ commit, state }) {
    try {
      const res = await Api.getShopByID()
      if (res && res.data) {
        if (!isFromBDAPP()) {
          commit('UPDATE_CURRENT_SHOP', {
            ...state.currentShop,
            businessType: res.data.businessType || 1,
          })
          commit('UPDATE_GLOBAL_PARAMS', {
            ...state.globalParams,
            shopBusinessType: res.data.businessType || 1,
          })
        }
        commit('UPDATE_CHANNEL_LIST', res.data.businessChannel || [1])
      }
    } catch (error) {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
